// Admin API client. One module per admin aggregate under `./api/`, each mirroring
// the API aggregate it calls; `api` is their union so call sites keep `api.<method>` (A7Y-774).

import { affiliatesApi } from './api/affiliates';
import { aiApisApi } from './api/ai-apis';
import { announcementsApi } from './api/announcements';
import { auditLogsApi } from './api/audit-logs';
import { auditSpendApi } from './api/audit-spend';
import { auditTestApi } from './api/audit-test';
import { authApi } from './api/auth';
import { autobuildApi } from './api/autobuild';
import { billingApi } from './api/billing';
import { blogApi } from './api/blog';
import { channelConsoleApi } from './api/channel-console';
import { contentApi } from './api/content';
import { contentKeysApi } from './api/content-keys';
import { crmApi } from './api/crm';
import { dashboardApi } from './api/dashboard';
import { docsApi } from './api/docs';
import { emailSuppressionsApi } from './api/email-suppressions';
import { errorsWarningsApi } from './api/errors-warnings';
import { featureFlagsApi } from './api/feature-flags';
import { featureStatusApi } from './api/feature-status';
import { financeApi } from './api/finance';
import { helmApi } from './api/helm';
import { learningTopicsApi } from './api/learning-topics';
import { messagingApi } from './api/messaging';
import { orgsApi } from './api/orgs';
import { platformHealthApi } from './api/platform-health';
import { productEmailsApi } from './api/product-emails';
import { projectsApi } from './api/projects';
import { promoCodesApi } from './api/promo-codes';
import { releaseNotesApi } from './api/release-notes';
import { serviceHealthApi } from './api/service-health';
import { shortLinksApi } from './api/short-links';
import { statsApi } from './api/stats';
import { subscriptionsApi } from './api/subscriptions';
import { systemApi } from './api/system';
import { ticketsApi } from './api/tickets';
import { trialEligibilityApi } from './api/trial-eligibility';
import { usersApi } from './api/users';

export { authFetch, setTokenProvider } from './api/transport';
export type { PaginatedResponse, TokenProvider, TokenProviderOptions } from './api/transport';
export type { BlogMutateResult, ContentMutateResult } from './api/content-transport';

export const api = {
  ...authApi,
  ...orgsApi,
  ...usersApi,
  ...billingApi,
  ...ticketsApi,
  ...systemApi,
  ...auditLogsApi,
  ...dashboardApi,
  ...featureFlagsApi,
  ...featureStatusApi,
  ...subscriptionsApi,
  ...promoCodesApi,
  ...productEmailsApi,
  ...errorsWarningsApi,
  ...auditTestApi,
  ...serviceHealthApi,
  ...emailSuppressionsApi,
  ...trialEligibilityApi,
  ...messagingApi,
  ...announcementsApi,
  ...releaseNotesApi,
  ...learningTopicsApi,
  ...projectsApi,
  ...autobuildApi,
  ...helmApi,
  ...crmApi,
  ...platformHealthApi,
  ...auditSpendApi,
  ...channelConsoleApi,
  ...financeApi,
  ...aiApisApi,
  ...statsApi,
  ...affiliatesApi,
  ...shortLinksApi,
  ...contentKeysApi,
  ...blogApi,
  ...docsApi,
  ...contentApi,
};
